import { apiClient } from '@/shared/services/client'
import type {
  NotificacionesDropdown,
  NotificacionesPaginadas,
  NotificacionesStats,
  FiltrosNotificaciones,
  MarcarLeidaResponse,
  MarcarTodasLeidasResponse,
} from '@/modules/notificaciones/types'

const BASE_URL = '/notificaciones'

/**
 * Obtiene las notificaciones para el dropdown del navbar.
 * Retorna las 5 más recientes no leídas + contador total.
 */
export async function getDropdownNotificaciones(): Promise<NotificacionesDropdown> {
  const response = await apiClient.get<NotificacionesDropdown>(`${BASE_URL}/dropdown/`)
  return response.data
}

/**
 * Obtiene el historial paginado de notificaciones con filtros.
 */
export async function getHistorialNotificaciones(
  filters?: FiltrosNotificaciones
): Promise<NotificacionesPaginadas> {
  const response = await apiClient.get<NotificacionesPaginadas>(`${BASE_URL}/historial/`, {
    params: filters,
  })
  return response.data
}

/**
 * Obtiene estadísticas de notificaciones (total, leídas, no leídas).
 */
export async function getStatsNotificaciones(): Promise<NotificacionesStats> {
  const response = await apiClient.get<NotificacionesStats>(`${BASE_URL}/stats/`)
  return response.data
}

/**
 * Marca una notificación como leída.
 * Retorna el nuevo contador de no leídas.
 */
export async function marcarComoLeida(notificacionId: number): Promise<MarcarLeidaResponse> {
  const response = await apiClient.post<MarcarLeidaResponse>(
    `${BASE_URL}/${notificacionId}/marcar-leida/`
  )
  return response.data
}

/**
 * Marca todas las notificaciones como leídas.
 * Retorna cuántas se marcaron.
 */
export async function marcarTodasLeidas(): Promise<MarcarTodasLeidasResponse> {
  const response = await apiClient.post<MarcarTodasLeidasResponse>(
    `${BASE_URL}/marcar-todas-leidas/`
  )
  return response.data
}
